import { Injectable, Injector } from '@angular/core';
import { Response, Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { LocationStrategy } from '@angular/common';
import { SaldoService } from 'app/resources/services';

@Injectable()
export class SessionService {
  private authBasic: string;
  private clientUuid: string;
  public clienteValePresenteFreteGratuito: boolean;
  private isVoucher: boolean;
  public UrlRedirecionamento: string;
  public http: Http;
  public location: Location;
  private locationStrategy: LocationStrategy;
  public path: string;
  public sessaoExpirada: boolean;
  private userUuid: string;
  private userId: number;
  public isCustomized = false;

  constructor(http: Http, locationStrategy: LocationStrategy) {
    this.http = http;
    this.locationStrategy = locationStrategy;
    this.location = (<any>this.locationStrategy)._platformLocation.location;
  }

  public setSession(data: any) {
    this.authBasic = data.authBasic;
    this.clientUuid = data.clientUuid;
    this.clienteValePresenteFreteGratuito = data.clienteValePresenteFreteGratuito;
    this.isVoucher = data.isVoucher;
    this.userId = data.cartao.id;
    this.userUuid = data.cartao.uuid;
  }

  public getUserId() {
    return this.userId;
  }

  public getUserUuid() {
    return this.userUuid;
  }

  public getAuthBasic() {
    return this.authBasic;
  }

  public getClientUuid() {
    return this.clientUuid;
  }

  public getClienteVale() {
    return this.clienteValePresenteFreteGratuito;
  }

  public getIsVoucher() {
    return this.isVoucher;
  }

  public invalidaSessao() {
    this.authBasic = undefined;
    this.clientUuid = undefined;
    this.clienteValePresenteFreteGratuito = undefined;
    this.isVoucher = undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/session-service.service.ts